import React, { Component } from 'react';
import axios from 'axios'
import { Grid } from 'semantic-ui-react'
import { serverIp, firebaseAuth, } from '../../../config/constants.js'
import * as UiConsts from '../../../config/UiConstants'
import MainCard from '../MainPageCards'
import { Sectionheader } from '../NewSiteParts'
//'./newDashboard/algoliaDashboard/AlgoliaMiscUtils'
import { checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';

export default class ViewTemplateSubCats extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user:'',
            admin:false,
            loading: true,
            templateSubCats: []
        }
    }


    componentDidMount() {

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++: ViewTemplateSubCats removeListener");
            if (user) {
                console.log("elx1 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                let uid = user.uid;

                if (user) {
                    console.log("maddx241 user is:" + user.email);
    
                    if (user.email) {
                        console.log("addx290 user.email  is:" + user.email);
                        this.setState({
                            user: user
                        })
    
                        //CHECK ALGOLIA FOR USER
                        checkAdminEmail(user.email, this.setAdminResult)
                    }
    
                } else {
                    console.log("rlx121 user NOT found");
                    this.setState({
                        authed: false,
                        // loading: false,
                        user: user,
                        uid: user.uid
                    })
                }

            

            } else {
                console.log("rlx121 user NOT found");

            }

            this.trackFbClicks();
        })

        this.loadTemplates();
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    /**
     * TRACK FACBOOK CLICKS
     */
    trackFbClicks = () => {
        console.log("fbx1 ++++ track fb clicks");

        if(this.props.match.params.fbId){
            console.log("fbx1 fbId is valid:"+this.props.match.params.fbId);

            var eventProperties = {
                // 'selection': 'template',
                 'fbId': this.props.match.params.fbId,
                 admin: this.state.admin
             }
 
           

        }else{
            console.log("fbx12 fbId is NULL");
        }
        
    }


    loadTemplates = () => {
        axios.post(serverIp + 'templates/getSubCatEntries', {
            apiKey: 'hlhkghgg',
            templateSubCategory: this.props.match.params.templateSubCategory
        })
            .then((response) => {
                console.log(response);
                console.log("stx1 response.templates size:" + response.data.templateSubCategories.length);
                this.setState({
                    templateSubCats: response.data.templateSubCategories,
                    loading: false
                })
                // this.setTemplates(response.templates);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {

        const templatesList = this.state.templateSubCats.map((template) =>

            <Grid.Column>
                <MainCard showMainForm={this.showMainForm}
                    image={template.subCatImageUrl}
                    imageSize='massive'
                    // itemTypeDescription={template.itemDescription}
                    itemTypeDescription={template.subCatTitle}
                   // itemType={template.templateType.itemType.itemType}
                    fullDescription={''}
                   // shortDescriptions={template.cost + ' UGX EA'}
                    showMainForm={this.props.showMainForm}
                    //templateId = {template.idtemplates}
                    templateType={template.subCateItemCode} 
                    admin={this.state.admin} />
            </Grid.Column>
        )

        return (

            this.state.loading ? <UiConsts.LoadingComponent /> :
                <div>
                    <Sectionheader
                        mainHeader={'Order custom t-shirt'}
                        subHeader={'Customize with words of your choosing'} />
                        <br/>
                    <Grid container stackable columns={3}>
                        {templatesList}
                    </Grid>
                </div>


        )
    }
}


// WEBPACK FOOTER //
// ./src/components/newSite/templates/ViewTemplateSubCats.js